import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { List, SignOut } from "@phosphor-icons/react";

const links = [
  { to: "/admin/dashboard", label: "Dashboard" },
  { to: "/admin/print-cards", label: "Print cards" },
  { to: "/admin/brand-qr", label: "Brand QR" },
  { to: "/cc/admin", label: "Checkpoint" },
  { to: "/cc/admin/mints", label: "Mints" },
];

export default function Nav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = React.useState(false);

  const handleLogout = async () => {
    await logout();
    nav("/admin/login");
  };

  return (
    <header className="sticky top-0 z-40 bg-white border-b border-black" data-testid="main-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16">
        <Link to={user ? "/admin/dashboard" : "/admin/login"} data-testid="brand-logo">
          <img src="/curb-crew-logo.svg" alt="Curb Crew Admin" className="h-10 w-auto" />
        </Link>

        <nav className="hidden md:flex items-center gap-6">
          {user &&
            links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                className={({ isActive }) =>
                  `label-tag pb-1 border-b-2 ${isActive ? "border-black" : "border-transparent"} hover:border-black`
                }
              >
                {l.label}
              </NavLink>
            ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <button
              onClick={handleLogout}
              className="label-tag px-4 py-2 border border-black brutal-btn flex items-center gap-2"
              data-testid="nav-logout"
            >
              <SignOut size={14} weight="bold" /> Logout
            </button>
          ) : (
            <Link
              to="/admin/login"
              className="label-tag px-4 py-2 bg-[color:var(--cc-yellow)] brutal-btn"
            >
              Admin login
            </Link>
          )}
        </div>

        <button className="md:hidden p-2" onClick={() => setOpen((v) => !v)} aria-label="Menu">
          <List size={22} weight="bold" />
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-black bg-white px-4 py-4 space-y-3">
          {user &&
            links.map((l) => (
              <Link key={l.to} to={l.to} className="block label-tag" onClick={() => setOpen(false)}>
                {l.label}
              </Link>
            ))}
          {user ? (
            <button onClick={handleLogout} className="label-tag">
              Logout
            </button>
          ) : (
            <Link to="/admin/login" className="block label-tag" onClick={() => setOpen(false)}>
              Admin login
            </Link>
          )}
        </div>
      )}
    </header>
  );
}
